import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { Query } from "../../schema/types/query/query";
import { Policy } from "../../schema/types/policy/entity";
import { TableActionsDropdown } from "../../newcomponents/table/components/tableActionsDropdown";
import { DeleteModal } from "../../components/modals/deleteModal";
import { OriginColumn } from "../../newcomponents/table/columns/wellKnown/originColumn";
import { nameOfKind } from "../../services/cpln";
import { Checkbox } from "antd";
import {
  getPolicyTableItem,
  PolicyTableItem,
  STORAGE_KEY_POLICY_LIST_HIDE_BUILTIN,
} from "../../mst/kinds/policy.helpers";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";

export const PolicyList: React.FC = () => {
  const [selectedLinks, setSelectedLinks] = React.useState<string[]>([]);
  const [action, setAction] = React.useState<string>("");

  const { kind, id } = useTableKindId("policy", "policy-list");
  const columns = useColumnsWithTagColumns<PolicyTableItem>(
    [
      NameDescriptionColumn(),
      {
        id: "targetKind",
        label: "Target Kind",
        enableHide: true,
        cell: ({ getValue }) => {
          const value = getValue() as string;
          return <span>{nameOfKind(value)}</span>;
        },
      },
      OriginColumn(),
      TagsColumn(),
      CreatedColumn(),
      LastModifiedColumn(),
    ],
    kind,
  );

  function getDefaultHideBuiltin() {
    const localValue = localStorage.getItem(STORAGE_KEY_POLICY_LIST_HIDE_BUILTIN);
    if (!localValue) {
      return true;
    }
    return localValue === "true" ? true : false;
  }
  const [hideBuiltin, setHideBuiltin] = React.useState(getDefaultHideBuiltin());
  React.useEffect(() => {
    localStorage.setItem(STORAGE_KEY_POLICY_LIST_HIDE_BUILTIN, String(hideBuiltin));
  }, [hideBuiltin]);

  const builtinQuery: Query = React.useMemo(
    () => ({
      kind: "policy",
      spec: {
        match: "all",
        terms: [
          {
            property: "origin",
            op: "!=",
            value: "builtin",
          },
        ],
      },
    }),
    [],
  );
  const query = hideBuiltin ? builtinQuery : undefined;

  const qData = useTableItemQueryData<Policy>(kind, { query: query });

  const policyTableItems = qData.visibleItems.map((item) => getPolicyTableItem({ item: item }));

  return (
    <>
      <Table<PolicyTableItem>
        title={"Policies"}
        data={policyTableItems}
        selectKey="selfLink"
        selectMode="multi"
        selections={selectedLinks}
        onSelectionsChange={setSelectedLinks}
        tableId={id}
        headerRenderer={() => {
          return (
            <>
              <Checkbox
                disabled={!!qData.query}
                checked={!!qData.query ? false : hideBuiltin}
                onChange={(e) => setHideBuiltin(e.target.checked)}
              >
                Hide Built-in Policies
              </Checkbox>
              <TableNewItemButton kind={kind} />
              <TableActionsDropdown
                kind={kind}
                selectionLinks={selectedLinks}
                options={[
                  {
                    key: "delete",
                    label: "Delete",
                    disabled: selectedLinks.length < 1,
                    danger: true,
                    callback: () => setAction("delete"),
                  },
                ]}
              />
              <TableHeaderRefreshButton onClick={qData.refetch} />
              <CustomTableCPLNQuery
                tableId={id}
                kind={kind}
                onQuery={qData.setCplnQuery}
                isLoading={qData.isLoading}
              />
            </>
          );
        }}
        enableFilter
        isLoading={qData.isLoading}
        onSortChange={qData.setSort}
        onSearchChange={qData.setSearch}
        isLoadingMore={qData.isLoadingMore}
        hasMore={qData.hasMore}
        onLoadMore={qData.fetchNextPage}
        columns={columns}
      />
      {action === "delete" ? (
        <DeleteModal
          kind={kind}
          onCancel={() => setAction("")}
          onComplete={() => {
            setAction("");
            setSelectedLinks([]);
            // TODO tablefix
            // When user queries and then deletes, this might be a problem
            qData.refetch();
          }}
          links={selectedLinks}
        />
      ) : null}
    </>
  );
};
